// https://github.com/mapbox/mapbox-gl-js/issues/10173#issuecomment-750489778
import mapboxgl from 'mapbox-gl'

mapboxgl.workerClass =
  // eslint-disable-next-line import/no-webpack-loader-syntax
  require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default
